import { createSelector } from '@ngrx/store';
import * as fromLineItems from '../reducers/line-items.reducer';

export const getDisconnectReasons = createSelector(
  fromLineItems.getFeatureLineItemState,
  fromLineItems.getDisconnectReasons
);
